import { Moment } from 'moment'

import { IDrug } from './drug'

export const doseMe: 'DoseMe' = 'DoseMe'
export const trial: 'Trial' = 'Trial'
export const customer: 'Customer' = 'Customer'
export const tdi: 'TDI' = 'TDI'
export const research: 'Research' = 'Research'

export type TPlanType = typeof doseMe | typeof trial | typeof customer | typeof tdi | typeof research

export interface IPlanDrug extends IDrug {
  maxCourseCount: number
}

export interface IPlan extends INewPlan {
  created: Moment
  updated: Moment
  id: number
  activeSubscriptions: number
}

export interface IChangedPlan extends INewPlan {
  created: Moment
  updated: Moment
  id: number
}

export interface INewPlan {
  description: string
  drugs: IPlanDrug[]
  type: TPlanType
  name: string
}

export interface ISelectCount {
  selected: boolean
  count: number
}

export interface ISelectCountHashmap {
  [id: string]: ISelectCount
}
